import ArrowDropDownCb from "./assets/arrow-drop-down-cb";
import ArrowDropUpCb from "./assets/arrow-drop-up-cb";
import Camera from "./assets/camera-icon";
import CarCrash from "./assets/car-crash";
import DeviceStatusIndicatorsDisablePendingIndicator from "./assets/device-status-indicators/device-disable-pending-indicator-icon";
import DeviceStatusIndicatorsDisabledIndicator from "./assets/device-status-indicators/device-disabled-indicator-icon";
import DeviceStatusIndicatorsEnablePendingIndicator from "./assets/device-status-indicators/device-enable-pending-indicator-icon";
import DeviceStatusIndicatorsLostData from "./assets/device-status-indicators/device-lost-data-icon";
import DeviceStatusIndicatorsNew from "./assets/device-status-indicators/device-new-icon";
import DeviceStatusIndicatorsNoSignalIndicator from "./assets/device-status-indicators/device-no-signal-indicator-icon";
import DeviceStatusIndicatorsSynchronizingIndicator from "./assets/device-status-indicators/device-synchronizing-indicator-icon";
import DeviceStatusIndicatorsUnavailableIndicator from "./assets/device-status-indicators/device-unavailable-indicator-icon";
import DeviceStatusIndicatorsUnpluggedIndicator from "./assets/device-status-indicators/device-unplugged-indicator-icon";
import DoubleCheck from "./assets/double-check-icon";
import EtaCb from "./assets/eta-cb";
import FiltersBrokenLink from "./assets/filters/broken-link";
import FiltersDirectionsCarCb from "./assets/filters/directions-car-cb";
import FiltersDriverCb from "./assets/filters/driver-cb";
import FiltersFaceRecognition from "./assets/filters/face-recognition-icon";
import FiltersFilterAltCb from "./assets/filters/filter-alt-cb";
import FiltersHourglass from "./assets/filters/hourglass";
import FiltersLink from "./assets/filters/link";
import FiltersSpeed from "./assets/filters/speed";
import FiltersTag from "./assets/filters/tag";
import FiltersVehicleGroupCb from "./assets/filters/vehicle-group-cb";
import GeofencesBase from "./assets/geofences/base";
import GeofencesClient from "./assets/geofences/client";
import GeofencesFuel from "./assets/geofences/fuel";
import GeofencesHome from "./assets/geofences/home";
import GeofencesMaintenance from "./assets/geofences/maintenance";
import GeofencesOther from "./assets/geofences/other";
import GeofencesSede from "./assets/geofences/sede";
import Gravity from "./assets/gravity/gravity";
import HeavyVehicle from "./assets/heavy-vehicle-icon";
import Help from "./assets/help-icon";
import Ibutton from "./assets/ibutton";
import Integrations from "./assets/integrations";
import Lan from "./assets/lan";
import Leading from "./assets/leading-icon";
import LightVehicle from "./assets/light-vehicle-icon";
import LoadingSpin from "./assets/loading/spin";
import Maintenance from "./assets/maintenance";
import MediumVehicle from "./assets/medium-vehicle-icon";
import NewRelease from "./assets/new-release-icon";
import Obd from "./assets/obd";
import PlaceholderCar from "./assets/placeholder/placeholder-car";
import PlaceholderChecklists from "./assets/placeholder/placeholder-checklists";
import PlaceholderVehicleGroup from "./assets/placeholder/placeholder-vehicle-group";
import Preferences from "./assets/preferences-icon";
import ReportLock from "./assets/report-lock";
import SearchSignal from "./assets/search-signal-icon";
import Settings from "./assets/settings-icon";
import SignalCellular0 from "./assets/signal-cellular-0";
import SignalCellular4 from "./assets/signal-cellular-4";
import SignalCellularOff from "./assets/signal-cellular-off";
import SignalDisconnected from "./assets/signal/disconnected";
import SignalNodata from "./assets/signal/nodata";
import SignalNormal from "./assets/signal/normal";
import SignalNosignal from "./assets/signal/nosignal";
import SignalUnavailable from "./assets/signal/unavailable";
import SortMenuAsc from "./assets/sort-menu-asc";
import SpeedLock from "./assets/speed-lock";
import StatusDanger from "./assets/status/danger";
import StatusInfo from "./assets/status/info";
import StatusInstallation from "./assets/status/installation";
import StatusProcessing from "./assets/status/processing";
import StatusSuccess from "./assets/status/success";
import StatusTracking from "./assets/status/tracking";
import StatusWarning from "./assets/status/warning";
import SteeringWheel from "./assets/steering-wheel";
import TrafficLight from "./assets/traffic-light-icon";
import Unplugged from "./assets/unplugged";
import VehicleSBoatDisablePending from "./assets/vehicle-icons/boat/boat-disable-pending";
import VehicleSBoatDisabled from "./assets/vehicle-icons/boat/boat-disabled";
import VehicleSBoatEnablePending from "./assets/vehicle-icons/boat/boat-enable-pending";
import VehicleSBoatNoSignal from "./assets/vehicle-icons/boat/boat-no-signal";
import VehicleSBoatOff from "./assets/vehicle-icons/boat/boat-off";
import VehicleSBoatOn from "./assets/vehicle-icons/boat/boat-on";
import VehicleSBoatUnavailable from "./assets/vehicle-icons/boat/boat-unavailable";
import VehicleSBoatUnplugged from "./assets/vehicle-icons/boat/boat-unplugged";
import VehicleSBoat from "./assets/vehicle-icons/boat/boat";
import VehicleSCarDisablePending from "./assets/vehicle-icons/car/car-disable-pending";
import VehicleSCarDisabled from "./assets/vehicle-icons/car/car-disabled";
import VehicleSCarEnablePending from "./assets/vehicle-icons/car/car-enable-pending";
import VehicleSCarNoSignal from "./assets/vehicle-icons/car/car-no-signal";
import VehicleSCarOff from "./assets/vehicle-icons/car/car-off";
import VehicleSCarOn from "./assets/vehicle-icons/car/car-on";
import VehicleSCarUnavailable from "./assets/vehicle-icons/car/car-unavailable";
import VehicleSCarUnplugged from "./assets/vehicle-icons/car/car-unplugged";
import VehicleSCar from "./assets/vehicle-icons/car/car";
import VehicleSConveyorDisablePending from "./assets/vehicle-icons/conveyor/conveyor-disable-pending";
import VehicleSConveyorDisabled from "./assets/vehicle-icons/conveyor/conveyor-disabled";
import VehicleSConveyorEnablePending from "./assets/vehicle-icons/conveyor/conveyor-enable-pending";
import VehicleSConveyorNoSignal from "./assets/vehicle-icons/conveyor/conveyor-no-signal";
import VehicleSConveyorOff from "./assets/vehicle-icons/conveyor/conveyor-off";
import VehicleSConveyorOn from "./assets/vehicle-icons/conveyor/conveyor-on";
import VehicleSConveyorUnavailable from "./assets/vehicle-icons/conveyor/conveyor-unavailable";
import VehicleSConveyorUnplugged from "./assets/vehicle-icons/conveyor/conveyor-unplugged";
import VehicleSConveyor from "./assets/vehicle-icons/conveyor/conveyor";
import VehicleSForkLiftDisablePending from "./assets/vehicle-icons/fork-lift/fork-lift-disable-pending";
import VehicleSForkLiftDisabled from "./assets/vehicle-icons/fork-lift/fork-lift-disabled";
import VehicleSForkLiftEnablePending from "./assets/vehicle-icons/fork-lift/fork-lift-enable-pending";
import VehicleSForkLiftNoSignal from "./assets/vehicle-icons/fork-lift/fork-lift-no-signal";
import VehicleSForkLiftOff from "./assets/vehicle-icons/fork-lift/fork-lift-off";
import VehicleSForkLiftOn from "./assets/vehicle-icons/fork-lift/fork-lift-on";
import VehicleSForkLiftUnavailable from "./assets/vehicle-icons/fork-lift/fork-lift-unavailable";
import VehicleSForkLiftUnplugged from "./assets/vehicle-icons/fork-lift/fork-lift-unplugged";
import VehicleSForkLift from "./assets/vehicle-icons/fork-lift/fork-lift";
import VehicleSGpuApuDisablePending from "./assets/vehicle-icons/gpu-apu/gpu-apu-disable-pending";
import VehicleSGpuApuDisabled from "./assets/vehicle-icons/gpu-apu/gpu-apu-disabled";
import VehicleSGpuApuEnablePending from "./assets/vehicle-icons/gpu-apu/gpu-apu-enable-pending";
import VehicleSGpuApuNoSignal from "./assets/vehicle-icons/gpu-apu/gpu-apu-no-signal";
import VehicleSGpuApuOff from "./assets/vehicle-icons/gpu-apu/gpu-apu-off";
import VehicleSGpuApuOn from "./assets/vehicle-icons/gpu-apu/gpu-apu-on";
import VehicleSGpuApuUnavailable from "./assets/vehicle-icons/gpu-apu/gpu-apu-unavailable";
import VehicleSGpuApuUnplugged from "./assets/vehicle-icons/gpu-apu/gpu-apu-unplugged";
import VehicleSGpuApu from "./assets/vehicle-icons/gpu-apu/gpu-apu";
import VehicleSLadderDisablePending from "./assets/vehicle-icons/ladder/ladder-disable-pending";
import VehicleSLadderDisabled from "./assets/vehicle-icons/ladder/ladder-disabled";
import VehicleSLadderEnablePending from "./assets/vehicle-icons/ladder/ladder-enable-pending";
import VehicleSLadderNoSignal from "./assets/vehicle-icons/ladder/ladder-no-signal";
import VehicleSLadderOff from "./assets/vehicle-icons/ladder/ladder-off";
import VehicleSLadderOn from "./assets/vehicle-icons/ladder/ladder-on";
import VehicleSLadderUnavailable from "./assets/vehicle-icons/ladder/ladder-unavailable";
import VehicleSLadderUnplugged from "./assets/vehicle-icons/ladder/ladder-unplugged";
import VehicleSLadder from "./assets/vehicle-icons/ladder/ladder";
import VehicleSLoaderDisablePending from "./assets/vehicle-icons/loader/loader-disable-pending";
import VehicleSLoaderDisabled from "./assets/vehicle-icons/loader/loader-disabled";
import VehicleSLoaderEnablePending from "./assets/vehicle-icons/loader/loader-enable-pending";
import VehicleSLoaderNoSignal from "./assets/vehicle-icons/loader/loader-no-signal";
import VehicleSLoaderOff from "./assets/vehicle-icons/loader/loader-off";
import VehicleSLoaderOn from "./assets/vehicle-icons/loader/loader-on";
import VehicleSLoaderUnavailable from "./assets/vehicle-icons/loader/loader-unavailable";
import VehicleSLoaderUnplugged from "./assets/vehicle-icons/loader/loader-unplugged";
import VehicleSLoader from "./assets/vehicle-icons/loader/loader";
import VehicleSMotorcycleDisablePending from "./assets/vehicle-icons/motorcycle/motorcycle-disable-pending";
import VehicleSMotorcycleDisabled from "./assets/vehicle-icons/motorcycle/motorcycle-disabled";
import VehicleSMotorcycleEnablePending from "./assets/vehicle-icons/motorcycle/motorcycle-enable-pending";
import VehicleSMotorcycleNoSignal from "./assets/vehicle-icons/motorcycle/motorcycle-no-signal";
import VehicleSMotorcycleOff from "./assets/vehicle-icons/motorcycle/motorcycle-off";
import VehicleSMotorcycleOn from "./assets/vehicle-icons/motorcycle/motorcycle-on";
import VehicleSMotorcycleUnavailable from "./assets/vehicle-icons/motorcycle/motorcycle-unavailable";
import VehicleSMotorcycleUnplugged from "./assets/vehicle-icons/motorcycle/motorcycle-unplugged";
import VehicleSMotorcycle from "./assets/vehicle-icons/motorcycle/motorcycle";
import VehicleSTractorDisablePending from "./assets/vehicle-icons/tractor/tractor-disable-pending";
import VehicleSTractorDisabled from "./assets/vehicle-icons/tractor/tractor-disabled";
import VehicleSTractorEnablePending from "./assets/vehicle-icons/tractor/tractor-enable-pending";
import VehicleSTractorNoSignal from "./assets/vehicle-icons/tractor/tractor-no-signal";
import VehicleSTractorOff from "./assets/vehicle-icons/tractor/tractor-off";
import VehicleSTractorOn from "./assets/vehicle-icons/tractor/tractor-on";
import VehicleSTractorUnavailable from "./assets/vehicle-icons/tractor/tractor-unavailable";
import VehicleSTractorUnplugged from "./assets/vehicle-icons/tractor/tractor-unplugged";
import VehicleSTractor from "./assets/vehicle-icons/tractor/tractor";
import VehicleSTruckDisablePending from "./assets/vehicle-icons/truck/truck-disable-pending";
import VehicleSTruckDisabled from "./assets/vehicle-icons/truck/truck-disabled";
import VehicleSTruckEnablePending from "./assets/vehicle-icons/truck/truck-enable-pending";
import VehicleSTruckNoSignal from "./assets/vehicle-icons/truck/truck-no-signal";
import VehicleSTruckOff from "./assets/vehicle-icons/truck/truck-off";
import VehicleSTruckOn from "./assets/vehicle-icons/truck/truck-on";
import VehicleSTruckUnavailable from "./assets/vehicle-icons/truck/truck-unavailable";
import VehicleSTruckUnplugged from "./assets/vehicle-icons/truck/truck-unplugged";
import VehicleSTruck from "./assets/vehicle-icons/truck/truck";
import VehicleSTugDisablePending from "./assets/vehicle-icons/tug/tug-disable-pending";
import VehicleSTugDisabled from "./assets/vehicle-icons/tug/tug-disabled";
import VehicleSTugEnablePending from "./assets/vehicle-icons/tug/tug-enable-pending";
import VehicleSTugNoSignal from "./assets/vehicle-icons/tug/tug-no-signal";
import VehicleSTugOff from "./assets/vehicle-icons/tug/tug-off";
import VehicleSTugOn from "./assets/vehicle-icons/tug/tug-on";
import VehicleSTugUnavailable from "./assets/vehicle-icons/tug/tug-unavailable";
import VehicleSTugUnplugged from "./assets/vehicle-icons/tug/tug-unplugged";
import VehicleSTug from "./assets/vehicle-icons/tug/tug";
import VehicleSVanDisablePending from "./assets/vehicle-icons/van/van-disable-pending";
import VehicleSVanDisabled from "./assets/vehicle-icons/van/van-disabled";
import VehicleSVanEnablePending from "./assets/vehicle-icons/van/van-enable-pending";
import VehicleSVanNoSignal from "./assets/vehicle-icons/van/van-no-signal";
import VehicleSVanOff from "./assets/vehicle-icons/van/van-off";
import VehicleSVanOn from "./assets/vehicle-icons/van/van-on";
import VehicleSVanUnavailable from "./assets/vehicle-icons/van/van-unavailable";
import VehicleSVanUnplugged from "./assets/vehicle-icons/van/van-unplugged";
import VehicleSVan from "./assets/vehicle-icons/van/van";
import VehicleStatusIndicatorsOffIndicator from "./assets/vehicle-status-indicators/vehicle-off-indicator-icon";
import VehicleStatusIndicatorsOffIndicatorOutlined from "./assets/vehicle-status-indicators/vehicle-off-indicator-outlined-icon";
import VehicleStatusIndicatorsOnIndicator from "./assets/vehicle-status-indicators/vehicle-on-indicator-icon";
import VehicleStatusIndicatorsOnIndicatorOutlined from "./assets/vehicle-status-indicators/vehicle-on-indicator-outlined-icon";
import Whatsapp from "./assets/whatsapp";
export default { "cb-arrow-drop-down-cb": ArrowDropDownCb,
    "cb-arrow-drop-up-cb": ArrowDropUpCb,
    "cb-camera": Camera,
    "cb-car-crash": CarCrash,
    "cb-device-status-indicators-disable-pending-indicator": DeviceStatusIndicatorsDisablePendingIndicator,
    "cb-device-status-indicators-disabled-indicator": DeviceStatusIndicatorsDisabledIndicator,
    "cb-device-status-indicators-enable-pending-indicator": DeviceStatusIndicatorsEnablePendingIndicator,
    "cb-device-status-indicators-lost-data": DeviceStatusIndicatorsLostData,
    "cb-device-status-indicators-new": DeviceStatusIndicatorsNew,
    "cb-device-status-indicators-no-signal-indicator": DeviceStatusIndicatorsNoSignalIndicator,
    "cb-device-status-indicators-synchronizing-indicator": DeviceStatusIndicatorsSynchronizingIndicator,
    "cb-device-status-indicators-unavailable-indicator": DeviceStatusIndicatorsUnavailableIndicator,
    "cb-device-status-indicators-unplugged-indicator": DeviceStatusIndicatorsUnpluggedIndicator,
    "cb-double-check": DoubleCheck,
    "cb-eta-cb": EtaCb,
    "cb-filters-broken-link": FiltersBrokenLink,
    "cb-filters-directions-car-cb": FiltersDirectionsCarCb,
    "cb-filters-driver-cb": FiltersDriverCb,
    "cb-filters-face-recognition": FiltersFaceRecognition,
    "cb-filters-filter-alt-cb": FiltersFilterAltCb,
    "cb-filters-hourglass": FiltersHourglass,
    "cb-filters-link": FiltersLink,
    "cb-filters-speed": FiltersSpeed,
    "cb-filters-tag": FiltersTag,
    "cb-filters-vehicle-group-cb": FiltersVehicleGroupCb,
    "cb-geofences-base": GeofencesBase,
    "cb-geofences-client": GeofencesClient,
    "cb-geofences-fuel": GeofencesFuel,
    "cb-geofences-home": GeofencesHome,
    "cb-geofences-maintenance": GeofencesMaintenance,
    "cb-geofences-other": GeofencesOther,
    "cb-geofences-sede": GeofencesSede,
    "cb-gravity": Gravity,
    "cb-heavy-vehicle": HeavyVehicle,
    "cb-help": Help,
    "cb-ibutton": Ibutton,
    "cb-integrations": Integrations,
    "cb-lan": Lan,
    "cb-leading": Leading,
    "cb-light-vehicle": LightVehicle,
    "cb-loading-spin": LoadingSpin,
    "cb-maintenance": Maintenance,
    "cb-medium-vehicle": MediumVehicle,
    "cb-new-release": NewRelease,
    "cb-obd": Obd,
    "cb-placeholder-car": PlaceholderCar,
    "cb-placeholder-checklists": PlaceholderChecklists,
    "cb-placeholder-vehicle-group": PlaceholderVehicleGroup,
    "cb-preferences": Preferences,
    "cb-report-lock": ReportLock,
    "cb-search-signal": SearchSignal,
    "cb-settings": Settings,
    "cb-signal-cellular-0": SignalCellular0,
    "cb-signal-cellular-4": SignalCellular4,
    "cb-signal-cellular-off": SignalCellularOff,
    "cb-signal-disconnected": SignalDisconnected,
    "cb-signal-nodata": SignalNodata,
    "cb-signal-normal": SignalNormal,
    "cb-signal-nosignal": SignalNosignal,
    "cb-signal-unavailable": SignalUnavailable,
    "cb-sort-menu-asc": SortMenuAsc,
    "cb-speed-lock": SpeedLock,
    "cb-status-danger": StatusDanger,
    "cb-status-info": StatusInfo,
    "cb-status-installation": StatusInstallation,
    "cb-status-processing": StatusProcessing,
    "cb-status-success": StatusSuccess,
    "cb-status-tracking": StatusTracking,
    "cb-status-warning": StatusWarning,
    "cb-steering-wheel": SteeringWheel,
    "cb-traffic-light": TrafficLight,
    "cb-unplugged": Unplugged,
    "cb-vehicle-s-boat-disable-pending": VehicleSBoatDisablePending,
    "cb-vehicle-s-boat-disabled": VehicleSBoatDisabled,
    "cb-vehicle-s-boat-enable-pending": VehicleSBoatEnablePending,
    "cb-vehicle-s-boat-no-signal": VehicleSBoatNoSignal,
    "cb-vehicle-s-boat-off": VehicleSBoatOff,
    "cb-vehicle-s-boat-on": VehicleSBoatOn,
    "cb-vehicle-s-boat-unavailable": VehicleSBoatUnavailable,
    "cb-vehicle-s-boat-unplugged": VehicleSBoatUnplugged,
    "cb-vehicle-s-boat": VehicleSBoat,
    "cb-vehicle-s-car-disable-pending": VehicleSCarDisablePending,
    "cb-vehicle-s-car-disabled": VehicleSCarDisabled,
    "cb-vehicle-s-car-enable-pending": VehicleSCarEnablePending,
    "cb-vehicle-s-car-no-signal": VehicleSCarNoSignal,
    "cb-vehicle-s-car-off": VehicleSCarOff,
    "cb-vehicle-s-car-on": VehicleSCarOn,
    "cb-vehicle-s-car-unavailable": VehicleSCarUnavailable,
    "cb-vehicle-s-car-unplugged": VehicleSCarUnplugged,
    "cb-vehicle-s-car": VehicleSCar,
    "cb-vehicle-s-conveyor-disable-pending": VehicleSConveyorDisablePending,
    "cb-vehicle-s-conveyor-disabled": VehicleSConveyorDisabled,
    "cb-vehicle-s-conveyor-enable-pending": VehicleSConveyorEnablePending,
    "cb-vehicle-s-conveyor-no-signal": VehicleSConveyorNoSignal,
    "cb-vehicle-s-conveyor-off": VehicleSConveyorOff,
    "cb-vehicle-s-conveyor-on": VehicleSConveyorOn,
    "cb-vehicle-s-conveyor-unavailable": VehicleSConveyorUnavailable,
    "cb-vehicle-s-conveyor-unplugged": VehicleSConveyorUnplugged,
    "cb-vehicle-s-conveyor": VehicleSConveyor,
    "cb-vehicle-s-fork-lift-disable-pending": VehicleSForkLiftDisablePending,
    "cb-vehicle-s-fork-lift-disabled": VehicleSForkLiftDisabled,
    "cb-vehicle-s-fork-lift-enable-pending": VehicleSForkLiftEnablePending,
    "cb-vehicle-s-fork-lift-no-signal": VehicleSForkLiftNoSignal,
    "cb-vehicle-s-fork-lift-off": VehicleSForkLiftOff,
    "cb-vehicle-s-fork-lift-on": VehicleSForkLiftOn,
    "cb-vehicle-s-fork-lift-unavailable": VehicleSForkLiftUnavailable,
    "cb-vehicle-s-fork-lift-unplugged": VehicleSForkLiftUnplugged,
    "cb-vehicle-s-fork-lift": VehicleSForkLift,
    "cb-vehicle-s-gpu-apu-disable-pending": VehicleSGpuApuDisablePending,
    "cb-vehicle-s-gpu-apu-disabled": VehicleSGpuApuDisabled,
    "cb-vehicle-s-gpu-apu-enable-pending": VehicleSGpuApuEnablePending,
    "cb-vehicle-s-gpu-apu-no-signal": VehicleSGpuApuNoSignal,
    "cb-vehicle-s-gpu-apu-off": VehicleSGpuApuOff,
    "cb-vehicle-s-gpu-apu-on": VehicleSGpuApuOn,
    "cb-vehicle-s-gpu-apu-unavailable": VehicleSGpuApuUnavailable,
    "cb-vehicle-s-gpu-apu-unplugged": VehicleSGpuApuUnplugged,
    "cb-vehicle-s-gpu-apu": VehicleSGpuApu,
    "cb-vehicle-s-ladder-disable-pending": VehicleSLadderDisablePending,
    "cb-vehicle-s-ladder-disabled": VehicleSLadderDisabled,
    "cb-vehicle-s-ladder-enable-pending": VehicleSLadderEnablePending,
    "cb-vehicle-s-ladder-no-signal": VehicleSLadderNoSignal,
    "cb-vehicle-s-ladder-off": VehicleSLadderOff,
    "cb-vehicle-s-ladder-on": VehicleSLadderOn,
    "cb-vehicle-s-ladder-unavailable": VehicleSLadderUnavailable,
    "cb-vehicle-s-ladder-unplugged": VehicleSLadderUnplugged,
    "cb-vehicle-s-ladder": VehicleSLadder,
    "cb-vehicle-s-loader-disable-pending": VehicleSLoaderDisablePending,
    "cb-vehicle-s-loader-disabled": VehicleSLoaderDisabled,
    "cb-vehicle-s-loader-enable-pending": VehicleSLoaderEnablePending,
    "cb-vehicle-s-loader-no-signal": VehicleSLoaderNoSignal,
    "cb-vehicle-s-loader-off": VehicleSLoaderOff,
    "cb-vehicle-s-loader-on": VehicleSLoaderOn,
    "cb-vehicle-s-loader-unavailable": VehicleSLoaderUnavailable,
    "cb-vehicle-s-loader-unplugged": VehicleSLoaderUnplugged,
    "cb-vehicle-s-loader": VehicleSLoader,
    "cb-vehicle-s-motorcycle-disable-pending": VehicleSMotorcycleDisablePending,
    "cb-vehicle-s-motorcycle-disabled": VehicleSMotorcycleDisabled,
    "cb-vehicle-s-motorcycle-enable-pending": VehicleSMotorcycleEnablePending,
    "cb-vehicle-s-motorcycle-no-signal": VehicleSMotorcycleNoSignal,
    "cb-vehicle-s-motorcycle-off": VehicleSMotorcycleOff,
    "cb-vehicle-s-motorcycle-on": VehicleSMotorcycleOn,
    "cb-vehicle-s-motorcycle-unavailable": VehicleSMotorcycleUnavailable,
    "cb-vehicle-s-motorcycle-unplugged": VehicleSMotorcycleUnplugged,
    "cb-vehicle-s-motorcycle": VehicleSMotorcycle,
    "cb-vehicle-s-tractor-disable-pending": VehicleSTractorDisablePending,
    "cb-vehicle-s-tractor-disabled": VehicleSTractorDisabled,
    "cb-vehicle-s-tractor-enable-pending": VehicleSTractorEnablePending,
    "cb-vehicle-s-tractor-no-signal": VehicleSTractorNoSignal,
    "cb-vehicle-s-tractor-off": VehicleSTractorOff,
    "cb-vehicle-s-tractor-on": VehicleSTractorOn,
    "cb-vehicle-s-tractor-unavailable": VehicleSTractorUnavailable,
    "cb-vehicle-s-tractor-unplugged": VehicleSTractorUnplugged,
    "cb-vehicle-s-tractor": VehicleSTractor,
    "cb-vehicle-s-truck-disable-pending": VehicleSTruckDisablePending,
    "cb-vehicle-s-truck-disabled": VehicleSTruckDisabled,
    "cb-vehicle-s-truck-enable-pending": VehicleSTruckEnablePending,
    "cb-vehicle-s-truck-no-signal": VehicleSTruckNoSignal,
    "cb-vehicle-s-truck-off": VehicleSTruckOff,
    "cb-vehicle-s-truck-on": VehicleSTruckOn,
    "cb-vehicle-s-truck-unavailable": VehicleSTruckUnavailable,
    "cb-vehicle-s-truck-unplugged": VehicleSTruckUnplugged,
    "cb-vehicle-s-truck": VehicleSTruck,
    "cb-vehicle-s-tug-disable-pending": VehicleSTugDisablePending,
    "cb-vehicle-s-tug-disabled": VehicleSTugDisabled,
    "cb-vehicle-s-tug-enable-pending": VehicleSTugEnablePending,
    "cb-vehicle-s-tug-no-signal": VehicleSTugNoSignal,
    "cb-vehicle-s-tug-off": VehicleSTugOff,
    "cb-vehicle-s-tug-on": VehicleSTugOn,
    "cb-vehicle-s-tug-unavailable": VehicleSTugUnavailable,
    "cb-vehicle-s-tug-unplugged": VehicleSTugUnplugged,
    "cb-vehicle-s-tug": VehicleSTug,
    "cb-vehicle-s-van-disable-pending": VehicleSVanDisablePending,
    "cb-vehicle-s-van-disabled": VehicleSVanDisabled,
    "cb-vehicle-s-van-enable-pending": VehicleSVanEnablePending,
    "cb-vehicle-s-van-no-signal": VehicleSVanNoSignal,
    "cb-vehicle-s-van-off": VehicleSVanOff,
    "cb-vehicle-s-van-on": VehicleSVanOn,
    "cb-vehicle-s-van-unavailable": VehicleSVanUnavailable,
    "cb-vehicle-s-van-unplugged": VehicleSVanUnplugged,
    "cb-vehicle-s-van": VehicleSVan,
    "cb-vehicle-status-indicators-off-indicator": VehicleStatusIndicatorsOffIndicator,
    "cb-vehicle-status-indicators-off-indicator-outlined": VehicleStatusIndicatorsOffIndicatorOutlined,
    "cb-vehicle-status-indicators-on-indicator": VehicleStatusIndicatorsOnIndicator,
    "cb-vehicle-status-indicators-on-indicator-outlined": VehicleStatusIndicatorsOnIndicatorOutlined,
    "cb-whatsapp": Whatsapp, };
